import PropTypes from 'prop-types';

import CloseButton from 'shared/components/button/CloseButton';
import CornerLoader from 'shared/components/loader/CornerLoader';
import UrlSharer from 'shared/components/UrlSharer';

import styles from './index.module.scss';

const LinkDialog = ({
  body,
  closeHandler,
  isPdf = false,
  mailBody,
  title,
  url,
}) => (
  <div className={styles.body}>
    <CloseButton onClick={closeHandler} />
    <CornerLoader visible={!url} inDialog />

    <div className={styles.header}>{title}</div>

    <p>{body}</p>
    <UrlSharer url={url} mailBody={mailBody} isPdf={isPdf} />
  </div>
);

LinkDialog.propTypes = {
  body: PropTypes.string.isRequired,
  closeHandler: PropTypes.func.isRequired,
  isPdf: PropTypes.bool,
  mailBody: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
};

export default LinkDialog;
